import RouteTemplate from 'ember-route-template';
import { PageLoading } from 'embroil/components/loading';

export default RouteTemplate(
  <template>
  <PageLoading @message="Loading streamers..." @subtitle="Finding gaming content creators and streamers" />
</template>
);
